/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MobilePushPayloadResponse } from '../models/MobilePushPayloadResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PushPayloadService {
    /**
     * Recover the stored recovery-MFA push payload for a notification tag
     * Recover the push payload the OS dropped, then delete it (single-use).
     * @param tag
     * @param xPushToken
     * @returns MobilePushPayloadResponse Successful Response
     * @throws ApiError
     */
    public static getPushPayload(
        tag: string,
        xPushToken: string,
    ): CancelablePromise<MobilePushPayloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/enrollment/push/payload/{tag}',
            path: {
                'tag': tag,
            },
            headers: {
                'x-push-token': xPushToken,
            },
            errors: {
                404: `Push payload not found or already consumed`,
                422: `Validation Error`,
            },
        });
    }
}
